<div class="row mb-5">
    <div class="col-lg-8 offset-lg-2 mb-4 mb-lg-0">
        <div class="card h-100">
            <div class="card-header">
                <h2 class="card-header-title">Cryptocurrency Prices</h2>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Price</th>
                        <th scope="col">Market Cap</th>
                        <th scope="col">Change (24hr)</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of btcTicketsAll| paginate: { itemsPerPage: 6, currentPage: page, totalItems: total }">
                            <th scope="row" style="width: 35%; white-space: nowrap; overflow: hidden; text-align:justify"><img src="https://cryptocompare.com{{item.CoinInfo.ImageUrl}}"  alt="" class="img-fluid" style="width:10%"> {{ item.CoinInfo.FullName }}</th>
                            <td>{{ item.DISPLAY.USD.PRICE }}</td>
                            <td>{{ item.DISPLAY.USD.MKTCAP }}</td>
                            <td style="font-weight: bold" [ngClass]="{'success': item.DISPLAY.USD.CHANGEPCTHOUR > 0, 'error': item.DISPLAY.USD.CHANGEPCTHOUR < 0 }">{{ item.DISPLAY.USD.CHANGEPCTHOUR }} %</td>
                        </tr>
                    </tbody>
                </table>
                <pagination-controls class="pagination" (pageChange)="pageChanged($event)"></pagination-controls>
            </div>
        </div>
    </div>
</div>